import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import Button from "../../extras/Button";
import { ExInput } from "../../extras/Input";
import { useDispatch, useSelector } from "react-redux";
import { closeDialog } from "../../../redux/slice/dialogueSlice";
import {
  allUserNotification,
  expertNotification,
  userNotification,
} from "../../../redux/slice/notificationSlice";


const NotificationDialog = () => {
  const dispatch = useDispatch();
  const { dialogueData } = useSelector((state) => state.dialogue);

  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [image, setImage] = useState([]);
  const [imagePath, setImagePath] = useState("");


  const [error, setError] = useState({
    title: "",
    message: "",
  });

  console.log("dialogueData", dialogueData);

  const handleSubmit = () => {

    if (!title || !message) {
      let error = {};
      if (!title) error.title = "Title is Required";
      if (!message) error.message = "Message is Required";
      return setError({ ...error });
    } else {
      if (image?.length !== 0) {
        let payload;
        const formData = new FormData();
        formData.append("title", title);
        formData.append("message", message);
        formData.append("image", image);
        if (dialogueData.type === "user") {
          payload = {
            data: formData,
            userId: dialogueData.id,
          };
          dispatch(userNotification(payload)).unwrap();
        } else if (dialogueData.type === "expert") {
          payload = {
            data: formData,
            expertId: dialogueData.id,
          };
          dispatch(expertNotification(payload)).unwrap();
        }
      } else {
        let payload;
        if (dialogueData.type === "user") {
          payload = {
            data: {
              title,
              message,
            },
            userId: dialogueData.id,
          };
          dispatch(userNotification(payload)).unwrap();
        } else if (dialogueData.type === "expert") {
          payload = {
            data: {
              title,
              message,
            },
            expertId: dialogueData.id,
          };
          dispatch(expertNotification(payload)).unwrap();
        }
      }
      dispatch(closeDialog());
    }
  };

  const handleAllUser = () => {
    let payload;
    if (!title || !message) {
      let error = {};
      if (!title) error.title = "Title is Required";
      if (!message) error.message = "Message is Required";
      return setError({ ...error });
    } else {
      if (image) {
        const formData = new FormData();
        formData.append("title", title);
        formData.append("message", message);
        formData.append("image", image);

        dispatch(allUserNotification(formData)).unwrap();
      } else {
        payload = {
          title,
          message,
        };
        dispatch(allUserNotification(payload)).unwrap();
      }
      dispatch(closeDialog());
    }
  };

  const handleImage = (e) => {
    setImage(e.target.files[0]);
    setImagePath(URL.createObjectURL(e.target.files[0]));
    setError((prevErrors) => ({
      ...prevErrors,
      image: "",
    }));
  };

  const dialogContent = (
    <div className="dialog">
      <div class="w-100">
        <div class="row justify-content-center">
          <div class="col-xl-4 col-md-6 col-11">
            <div class="mainDiaogBox" style={{ zIndex: 9999 }}>
              <div class="row justify-content-between align-items-center formHead">
                <div className="col-8">
                  <h2 className="text-theme m0">
                    {dialogueData == null
                      ? "User Notification"
                      : "Notification"}
                  </h2>
                </div>
                <div className="col-4">
                  <div
                    className="closeButton"
                    onClick={() => {
                      dispatch(closeDialog());
                    }}
                  >
                    <i className="ri-close-line"></i>
                  </div>
                </div>
              </div>
              <div className="row align-items-start formBody">
                <div className="col-6">
                  <ExInput
                    type={`text`}
                    id={`title`}
                    name={`title`}
                    value={title}
                    label={`Title`}
                    placeholder={`Title`}
                    errorMessage={error && error.title}
                    onChange={(e) => {
                      setTitle(e.target.value);
                      if (!e.target.value) {
                        setError({
                          title: "Title Is Required",
                        });
                      } else {
                        setError({
                          title: "",
                        });
                      }
                    }}
                  />
                </div>

                <div className="col-6">
                  <ExInput
                    type={`text`}
                    id={`message`}
                    name={`message`}
                    value={message}
                    label={`Message`}
                    placeholder={`Message`}
                    errorMessage={error && error.message}
                    onChange={(e) => {
                      setMessage(e.target.value);
                      if (!e.target.value) {
                        setError({
                          message: "Message Is Required",
                        });
                      } else {
                        setError({
                          message: "",
                        });
                      }
                    }}
                  />
                </div>

                <div className="col-6">
                  <ExInput
                    label={`Image`}
                    id={`image`}
                    type={`file`}
                    onChange={(e) => handleImage(e)}
                    errorMessage={error.image && error.image}
                    accept={"image/*"}
                  />
                  <img
                    src={imagePath !== "" ? imagePath : null}
                    alt=""
                    draggable="false"
                    className={`${(!imagePath || imagePath === "") && "d-none"
                      } `}
                    data-class={`showImage`}
                    style={{ width: "100px", height: "100px" }}
                  />
                </div>
              </div>
              <div className="row  formFooter">
                <div className="col-12 text-end m0">
                  <Button
                    className={`bg-gray text-light`}
                    text={`Cancel`}
                    type={`button`}
                    onClick={() => dispatch(closeDialog())}
                  />
                  {dialogueData && (
                    <Button
                      type={`submit`}
                      className={`bg-theme text-light m10-left`}
                      text={`Submit`}
                      onClick={(e) => handleSubmit(e)}
                    />
                  )}
                  {dialogueData == null && (
                    <Button
                      type={`submit`}
                      className={`bg-theme text-light m10-left`}
                      text={`Submit`}
                      onClick={(e) => handleAllUser(e)}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(
    dialogContent,
    document.body
  );
};

export default NotificationDialog;
